import {DataRoomGrouping} from './DataRoomGrouping'
import {DataRoomSearchComponent} from './DataRoomSearchComponent'
import {DataRoomToolbar} from './DataRoomToolbar'

const DataRoomHeader = ({
  onHeaderAction,
  subFoldderClicked,
  folderPath,
  folderId,
  onFlieFolderCreated,
  onSearchTermChange,
  selectedItems,
  searchTerm,
  setSearchTerm,
  currentAuditContext,
}) => {
  return (
    <div className='card-header border-0 pt-6'>
      <DataRoomSearchComponent
        onSearchTermChange={onSearchTermChange}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <div className='card-toolbar d-flex justify-content-end'>
        {selectedItems.length > 0  ? <DataRoomGrouping selectedItems={selectedItems} currentAuditContext={currentAuditContext}/> : <DataRoomToolbar onHeaderAction={onHeaderAction} subFolderClicked={subFoldderClicked} folderPath={folderPath} folderId={folderId} fileFolderCreated={onFlieFolderCreated} currentAuditContext={currentAuditContext}/>}
      </div>
    </div>
  )
}

export {DataRoomHeader}
